<template>
  <div class="basic-block lead-login" :style="styles">
    <div class="lead-login__text">占いTV月額528円(税込)</div>
    <a href="/user/login" class="lead-login__link">占いTV月額会員ログインはこちら</a>
  </div>
</template>

<script>
export default {
  name: 'LeadLogin',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed: {
    styles(){
      return {
        '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : 'black',
        // '--second': !!this.colorScheme.second ? this.colorScheme.second : 'white',
        // '--grad-start': !!this.gradStart ? this.gradStart : this.colorScheme.gradStart,
        // '--grad-end': !!this.gradEnd ? this.gradEnd : this.colorScheme.gradEnd,
        // '--def-gradient': grad,
      }
    },
  },
  methods: {
    clicked(){
      if(!this.isDisabled) {
        this.$emit('clicked')
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
//$l_col_second: var(--second);
// $l_col_grad_start: var(--grad-start);
// $l_col_grad_end: var(--grad-end);
// $l_def_gradient: var(--def-gradient);

.lead-login {
  text-align: center;
  padding: 8px 0 0;
  &__text {
    font-weight: 600;
    font-size: 11px;
    line-height: 16px;
    color: $l_col_keycolor;
    margin: 0 0 4px;
  }
  &__link {
    display: table;
    margin: auto;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-decoration-line: underline;
    color: $l_col_keycolor;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/LeadLogin.vue